import React from 'react';
import { Button } from '@TouchTask/pkg-components';
import { useDispatch, useSelector } from 'react-redux';
import AuthAction from '../../redux/actions/authActions/Actions';
import { AuthService } from '../../services/AuthService';
import { User } from '../../models/User';

import './Home.scss';
import Header from '../Header/Header';

function Home() {
  const dispatch = useDispatch();
  const user: User = useSelector((state: any) => state.auth);

  const logout = async () => {
    await AuthService.logout();
    dispatch(AuthAction.signOut({}));
  };
  const heightOffset = 75;
  const vh = window.innerHeight;
  const vw = window.innerWidth;

  return (
    <Header>
    <div
      style={{
        display: 'flex',
        marginTop: `${heightOffset}px`,
        width: `${vw}px`,
        height: `${vh - heightOffset}px`,
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: '400px',
          display: 'flex',
          gap: '20px',
          flexDirection: 'column',
        }}
      >
        <p>
          Bievenido usuario:{' '}
          <b>
            {user.name} {user.lastname}
          </b>
        </p>

        <pre
          style={{
            overflowX: 'auto',
            backgroundColor: '#f4f4f4',
            padding: '20px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            maxHeight: '70vh',
            fontFamily: `'Courier New', Courier, monospace`,
            color: '#333',
            fontSize: '13px',
          }}
        >
          {JSON.stringify(user, null, 2)}
        </pre>

        <Button
          label="Cerrar sesión"
          primary
          onClick={() => {
            logout();
          }}
        />
      </div>
    </div>

    </Header>

  );
}

export default Home;
